import React, { useEffect } from 'react';
import Payment from '../Components/Payment';
import Navbar from '../Components/Navbar';
import { useContext } from 'react';
import { userContext } from '../App';
import { toast } from 'react-toastify';
import { useNavigate} from 'react-router-dom';

const Purchase = () => {
  const {user, setUser} = useContext(userContext);
  let navigate = useNavigate()


  useEffect(() => {
    if(user === null) {
    toast.warn('You need to register before paying', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => navigate('/auth'), 1500)
  }
  }, [user])

  const LoggedInUserRender = () => {
    return (
      <div>
        <Navbar></Navbar>
        <Payment></Payment>
      </div>
    )
  }

  const LoggedOutUserRender = () => {
    return (
      <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <Navbar></Navbar>
        <div style={{height: '100%', display: 'flex'}}>
          <h3 style={{alignSelf: 'center', color: 'black'}}>You need to be logged in, to purchase the course</h3>
        </div>
      </div>
    )
  }
  
  return (
    <div style={{height: '100%'}}>
      { (user === null) ? LoggedOutUserRender() : LoggedInUserRender()}
    </div>
  )
};

export default Purchase;
